const API_KEY = process.env.REACT_APP_FINNHUB_API_KEY;
const BASE = 'https://finnhub.io/api/v1';

export async function getQuote(ticker) {
  try {
    const res = await fetch(`${BASE}/quote?symbol=${ticker}&token=${API_KEY}`);
    const data = await res.json();
    if (data.c && data.c > 0) {
      return { price: data.c, volume: data.v || null };
    }
    return null;
  } catch (e) {
    console.error(`Error fetching ${ticker}:`, e);
    return null;
  }
}

export async function getQuotes(tickers) {
  const results = {};
  for (let i = 0; i < tickers.length; i += 5) {
    const batch = tickers.slice(i, i + 5);
    const promises = batch.map(async (ticker) => {
      const quote = await getQuote(ticker);
      if (quote) results[ticker] = quote;
    });
    await Promise.all(promises);
    if (i + 5 < tickers.length) {
      await new Promise(r => setTimeout(r, 1200));
    }
  }
  return results;
}

/**
 * Fetch historical candle (OHLCV) data from Finnhub
 */
export async function getCandles(ticker, resolution = 'D', fromTimestamp, toTimestamp) {
  try {
    if (!toTimestamp) toTimestamp = Math.floor(Date.now() / 1000);
    if (!fromTimestamp) fromTimestamp = toTimestamp - (365 * 24 * 60 * 60);

    const url = `${BASE}/stock/candle?symbol=${ticker}&resolution=${resolution}&from=${fromTimestamp}&to=${toTimestamp}&token=${API_KEY}`;
    const res = await fetch(url);
    const data = await res.json();

    if (data.s === 'no_data' || !data.c) {
      console.warn(`No candle data for ${ticker}`);
      return null;
    }

    return data;
  } catch (e) {
    console.error(`Error fetching candles for ${ticker}:`, e);
    return null;
  }
}
